import { List } from '@kerfjs/ui/list';
import { ListItem } from '@kerfjs/ui/list-item';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import type { SafeHtml } from 'kerfjs';
import { ChartNoAxesCombined, ReceiptText, Scale } from 'lucide';

import type { EvidenceSection } from './evidence-sections.js';

export function EvidenceSectionList({ active }: { active: EvidenceSection }): SafeHtml {
  return (
    <List className="evidence-section-list line-evidence-list" gap="2xs" scrollable={true} controlInsets="trbl">
      <ListItem
        label="Pricing Result"
        icon={<LucideIcon icon={ChartNoAxesCombined} name="" />}
        action="evidence-view"
        itemId="pricing"
        selected={active === 'pricing'}
      />
      <ListItem
        label="Vendor Quotes"
        icon={<LucideIcon icon={ReceiptText} name="" />}
        action="evidence-view"
        itemId="quotes"
        selected={active === 'quotes'}
      />
      <ListItem
        label="Benchmarks"
        icon={<LucideIcon icon={Scale} name="" />}
        action="evidence-view"
        itemId="benchmarks"
        selected={active === 'benchmarks'}
      />
    </List>
  );
}
